<template>
  <tbody>
    <tr v-for="item in items" :key="item.id" class="text-xs-center hovereable">
      <td width="10%">
        <v-icon x-large class="k-orange-linear-text text--darken-2">fas fa-tags</v-icon>
      </td>
      <td class="text-xs-left">
        {{ item.name }}
      </td>
      <td  width="15%">
        <v-chip medium class="green white--text" v-if="item.type === 'payment_promise'">
          <v-icon class="pr-2 white--text" small>fas fa-check</v-icon>
          Compromiso
        </v-chip>
        <v-chip medium class="yellow darken-2 white--text" v-if="item.type === 'next_contact'">
          <v-icon class="pr-2 white--text" small>fas fa-clock</v-icon>
          Próximo contacto
        </v-chip>
        <v-chip medium class="blue lighten-2 white--text" v-if="item.type === 'movement'">
          <v-icon class="pr-2 white--text" small>fas fa-exchange-alt</v-icon>
          Movimiento
        </v-chip>
        <v-chip medium class="error lighten-2 white--text" v-if="item.type === 'black_list'">
          <v-icon class="pr-2 white--text" small>fas fa-ban</v-icon>
          Lista negra
        </v-chip>
        <v-chip medium class="grey white--text" v-if="item.type === 'unsolved'">
          <v-icon class="pr-2 white--text" small>fas fa-clock</v-icon>
          Sin resolver
        </v-chip>
      </td>
      <td v-if="checkCreate()" class="text-xs-right">
        <v-menu bottom offset-y>
          <v-btn slot="activator" color="grey darken-2" small flat fab>
            <v-icon>fas fa-ellipsis-v</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="editListItem(item)">
              <v-list-tile-title>Editar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('doEvent', { event: 'deleteItem', id: item.id, name: item.name })">
              <v-list-tile-title>Eliminar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </tbody>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableList';
import permissionsMixin from '@/mixins/permissions';

export default {
  mixins: [
    dataTableMixin,
    permissionsMixin,
  ],
  props: [
    'items',
  ],
  data() {
    return {
      route: 'chat_categories',
    };
  },
  methods: {
    editListItem(item) {
      this.$parent.$emit('listElementEdit', item);
    },
    checkCreate(){
      return this.checkPermissions([
        'create_chat_categories',
      ]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/ChatCategoriesList.vue